import Vue from 'vue'
import Card from '@/components/base/Card'
import Jumbotron from '@/components/base/Jumbotron'
import Title from '@/components/base/Title'

Vue.component('BaseCard', Card)
Vue.component('BaseJumbotron', Jumbotron)
Vue.component('BaseTitle', Title)
